export const blockIconsContentBlock = (
	<span className='material-symbols-outlined'>block</span>
);
